import { Icon } from '@iconify/react';
import React, { useEffect, useState, useRef } from 'react'; // added useRef
import { pageTitle } from '../../helper';
import Div from '../Div';
import PageHeading from '../PageHeading';
import Spacing from '../Spacing';
import Swal from '../../utils/darkSwal';
import BASE_URL from '../../utils/api';
import { useNavigate, Link } from 'react-router-dom';

export default function RegisterPage() {
  pageTitle('Register');

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); // NEW
  const [userName, setUserName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState(''); // NEW
  const [phoneNumber, setPhoneNumber] = useState('');
  const [address, setAddress] = useState('');
  const navigate = useNavigate();

  // Ref for "Create Your Account" heading
  const titleRef = useRef(null); // NEW

  useEffect(() => {
    // Smoothly scroll the heading into view on mount
    //titleRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }); // NEW
    // If a fixed header overlaps the title, use this pattern instead:
    const el = titleRef.current;
    if (el) {
      const y = el.getBoundingClientRect().top + window.pageYOffset - 140; // adjust offset
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }, []);

  const handleRegister = async () => {
    // Required fields check now includes confirmPassword
    if (!userName || !email || !password || !confirmPassword || !phoneNumber || !address) {
      Swal.fire({
        icon: 'warning',
        title: 'Missing Information',
        text: 'Please fill out all the fields.',
        confirmButtonColor: '#1344af',
      });
      return;
    }

    // Passwords must match
    if (password !== confirmPassword) {
      Swal.fire({
        icon: 'error',
        title: 'Passwords do not match',
        text: 'Please ensure both password fields match.',
        confirmButtonColor: '#1344af',
      });
      return;
    }

    Swal.fire({
      title: 'Please wait...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await fetch(`${BASE_URL}/api/users/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          userName,
          email,
          password,
          phoneNumber,
          address,
          status: 'active',
        }),
      });

      const data = await response.json();

      if (response.status === 201) {
        Swal.fire({
          icon: 'success',
          title: 'Registration Successful',
          text: 'You can now login to your account.',
          confirmButtonColor: '#1344af',
        }).then(() => {
          navigate('/login');
        });
      } else {
        if (data.message === 'Email is already registered') {
          Swal.fire({
            icon: 'error',
            title: 'Email Exists',
            text: 'This email address is already registered. Please use a different one or login.',
            confirmButtonColor: '#1344af',
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Registration Failed',
            text: data.message || 'Something went wrong. Please try again later.',
            confirmButtonColor: '#1344af',
          });
        }
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Network Error',
        text: 'Failed to connect to the server.',
        confirmButtonColor: '#1344af',
      });
    }
  };

  return (
    <>
      <PageHeading
        title="Register"
        bgSrc="/images/portfolio_hero_bg.jpeg"
        pageLinkText="Register"
      />
      <Spacing lg="150" md="80" />
      <Div className="container">
        <Div className="row justify-content-center">
          <Div className="col-lg-6">
            <h3 ref={titleRef} className="text-center cs-primary_color">Create Your Account</h3> {/* ref added */}
            <Spacing lg="30" md="20" />
            <form action="#" className="row">
              <Div className="col-sm-12">
                <label className="cs-primary_color">Username*</label>
                <input
                  type="text"
                  className="cs-form_field"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  autoComplete="username"
                />
                <Spacing lg="20" md="20" />
              </Div>

              <Div className="col-sm-12">
                <label className="cs-primary_color">Email*</label>
                <input
                  type="email"
                  className="cs-form_field"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                />
                <Spacing lg="20" md="20" />
              </Div>

              <Div className="col-sm-12">
                <label className="cs-primary_color">Password*</label>
                <div className="position-relative">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    className="cs-form_field"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    minLength={8}
                    autoComplete="new-password"
                  />
                  <span
                    style={{
                      position: 'absolute',
                      right: '15px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      cursor: 'pointer',
                    }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <Icon icon={showPassword ? 'mdi:eye-off' : 'mdi:eye'} />
                  </span>
                </div>
                <Spacing lg="20" md="20" />
              </Div>

              {/* NEW Confirm Password field */}
              <Div className="col-sm-12">
                <label className="cs-primary_color">Confirm Password*</label>
                <div className="position-relative">
                  <input
                    type={showConfirmPassword ? 'text' : 'password'}
                    className="cs-form_field"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    minLength={8}
                    autoComplete="new-password"
                  />
                  <span
                    style={{
                      position: 'absolute',
                      right: '15px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      cursor: 'pointer',
                    }}
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    <Icon icon={showConfirmPassword ? 'mdi:eye-off' : 'mdi:eye'} />
                  </span>
                </div>
                <Spacing lg="20" md="20" />
              </Div>

              <Div className="col-sm-12">
                <label className="cs-primary_color">Phone Number*</label>
                <input
                  type="text"
                  className="cs-form_field"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
                <Spacing lg="20" md="20" />
              </Div>

              <Div className="col-sm-12">
                <label className="cs-primary_color">Address*</label>
                <input
                  type="text"
                  className="cs-form_field"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
                <Spacing lg="30" md="20" />
              </Div>

              <Div className="col-sm-12 d-flex justify-content-center">
                <button
                  type="button"
                  className="cs-btn cs-style1"
                  onClick={handleRegister}
                >
                  <span>Register Now</span>
                  <Icon icon="bi:arrow-right" />
                </button>
              </Div>

              <Div className="col-sm-12 text-center mt-3">
                <p className="cs-primary_color">
                  Already have an account?{' '}
                  <Link to="/login" style={{ color: '#1344af' }}>
                    Login here
                  </Link>
                </p>
              </Div>
            </form>
          </Div>
        </Div>
      </Div>
      <Spacing lg="150" md="40" />
    </>
  );
}
